import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Input } from '@angular/core';
import { distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { CustomerSidenavService } from '../../services/customer-sidenav.service';

@Component({
  standalone: false,
  selector: 'app-customer-header',
  templateUrl: './customer-header.component.html',
  styleUrls: ['./customer-header.component.scss'],
})
export class CustomerHeaderComponent {
  private readonly unsubscribe$ = new Subject<void>();

  @Input() showBreadcrumbBackButton = false;
  @Input() disableFirstBreadcrumbLink = false;

  showMenuButton = false;

  constructor(
    private customerSidenavService: CustomerSidenavService,
    private breakpointObserver: BreakpointObserver,
  ) {
    this.breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium])
      .pipe(takeUntil(this.unsubscribe$), distinctUntilChanged())
      .subscribe((result) => {
        if (result.matches) {
          this.showMenuButton = true;
        } else {
          this.showMenuButton = false;
        }
      });
  }

  toggle() {
    this.customerSidenavService.toggle();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
